var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutlineMessageCircleLines2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 6.33333H10M5.33333 9H8.66667M2.00002 7.66669C1.99772 8.5466 2.20331 9.41461 2.60002 10.2C3.0704 11.1412 3.79352 11.9328 4.68839 12.4862C5.58325 13.0396 6.61452 13.3329 7.66669 13.3334C8.5466 13.3356 9.41461 13.1301 10.2 12.7334L14 14L12.7334 10.2C13.1301 9.41461 13.3356 8.5466 13.3334 7.66669C13.3329 6.61452 13.0396 5.58325 12.4862 4.68839C11.9328 3.79352 11.1412 3.0704 10.2 2.60002C9.41461 2.20331 8.5466 1.99772 7.66669 2.00002H7.33335C5.94379 2.07668 4.63132 2.66319 3.64726 3.64726C2.66319 4.63132 2.07668 5.94379 2.00002 7.33335V7.66669Z",
    stroke: "#828282",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineMessageCircleLines2);
export default __webpack_public_path__ + "static/media/outline-message-circle-lines-2.a3e488b6.svg";
export { ForwardRef as ReactComponent };